import _ from "lodash";
import {
  assignProjectToSupervisorMutation,
  inviteProjectGroupSupervisorMutation,
  assignSupervisorToProjectMutation,
  inviteProjectStudentMutation,
  inviteProjectGroupStudentsMutation,
  portfolioUpdateSupervisorAllocationForStudentMutation,
  portfolioUpdateStudentsAllocationForSupervisorMutation,
  updateProjectGroupSupervisorApprovalStatusMutation,
} from "./InviteMutations";
import {
  getProjectGroupProjectsQuery,
  getProjectGroupProjectsCountQuery,
  getProjectGroupSupervisorsQuery,
  getProjectGroupSupervisorsWithTypeCountQuery,
  getProjectGroupStudentCountQuery,
  getProjectGroupStudentsQuery,
  getSupervisorProjectsQuery,
  getProjectGroupSupervisorsWithPortfoliosQuery,
  getProjectGroupStudentsWithProjectsQuery,
  getProjectGroupStudentsWithPortfoliosQuery,
  getProjectGroupStudentPortfoliosQuery,
  getProjectGroupSupervisorsProjectsWithFieldsQuery,
  getProjectGroupSupervisorApprovalInfoWithProjectsQuery,
  getProjectGroupInternalSupervisorPendingApprovalCountQuery,
  getProjectGroupExternalSupervisorsWithProjectsQuery,
  getProjectGroupExternalSupervisorPendingApprovalCountQuery,
} from "./InviteQueries";
import {
  writeProjectGroupProjectInCache,
  getProjectGroupProjectFromCache,
  getStudentProjectPortfolioDetailsFromCache,
  writeStudentProjectPortfolioDetailsFragmentInCache,
  writeProjectGroupStudentProjectFragmentInCache,
  getProjectGroupStudentProjectFragmentFromCache,
  getProjectGroupStudentPortfolioFragmentFromCache,
  writeProjectGroupStudentPortfolioFragmentInCache,
  readProjectGroupSupervisorApprovalStatusFragmentFromCache,
  writeProjectGroupSupervisorApprovalStatusInCache,
} from "./InviteGraphqlHelpers";
import client from "lib/apolloClient/client";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import asyncWrap from "Utils/asyncWrap";
import update from "immutability-helper";
import {
  getCurrentProjectGroupDetails,
  entityNameOrderBy,
} from "Projects/modules/ProjectModules";
import {
  PROJECT_GROUP_TYPE_COMMUNITY,
  PROJECT_GROUP_TYPE_PERSONAL,
  SUPERVISOR_APPROVAL_STATUS_PENDING,
  PROJECT_SUPERVISOR_TYPE_INTERNAL,
  PROJECT_SUPERVISOR_TYPE_EXTERNAL,
  PROJECT_ARCHIVAL_STATES,
} from "Projects/Constants/stringConstants";
import {
  getOrderByFieldsMemoized,
  getShouldFetchFields,
} from "Projects/modules/Utils";
import {
  ASC,
  STUDENT_USER,
  STAFF_USER,
  FIRST_NAME,
} from "Constants/stringConstants";
import {
  getDefaultNameSortPreference,
  getSelectedAcademicYearId,
} from "modules/CommonSelectors";

export const NAME = "invite";

export const UPDATE_FILTER = "UPDATE_FILTER" + " " + NAME;
export const RESET_FILTER = "RESET_FILTER" + " " + NAME;

// constants for pagination

export const SUPERVISOR_FIRST_COUNT = 20;

export const STUDENT_COMMUNITY_FIRST_COUNT = 20;

export const STUDENT_FIRST_COUNT = 20;

export const BULK_MAP_ADVISER_FIRST_COUNT = 25;

// check if this can be removed

export const assignProjectToSupervisor = ({
  projectId,
  addedArray,
  removedArray,
  projectGroupId,
  supervisor,
  supervisorsArray = [],
  filterVariables = {},
  extraParams: { type = "" } = {},
  projectGroupType,
}) => {
  return async (dispatch, getState) => {
    // if nothing to update dont fire mutation
    if (
      (_.isEmpty(addedArray) && _.isEmpty(removedArray)) ||
      _.isEqual(_.sortBy(addedArray), _.sortBy(removedArray))
    ) {
      return;
    }
    let data = [];
    const academicYearId = getSelectedAcademicYearId(getState());
    switch (type) {
      case "assign_with_invite":
        {
          data = getProjectGroupStudentProjectFragmentFromCache({
            id: projectId,
            projectFieldFilters: _.get(
              filterVariables,
              "projectFieldFilters",
              {}
            ),
            fetchFields: getShouldFetchFields({
              projectGroupType,
            }),
            fetchProjects: true,
            fetchProjectStudents: _.isEqual(
              projectGroupType,
              PROJECT_GROUP_TYPE_COMMUNITY
            ),
            academicYearId,
          });

          writeProjectGroupStudentProjectFragmentInCache({
            id: projectId,
            academicYearId,
            projectFieldFilters: _.get(
              filterVariables,
              "projectFieldFilters",
              {}
            ),
            fetchFields: getShouldFetchFields({
              projectGroupType,
            }),
            fetchProjects: true,
            fetchProjectStudents: _.isEqual(
              projectGroupType,
              PROJECT_GROUP_TYPE_COMMUNITY
            ),
            data: update(data, {
              supervisors: {
                $set: !_.isEmpty(supervisorsArray)
                  ? supervisorsArray
                  : _.isEmpty(supervisor)
                  ? []
                  : [supervisor],
              },
            }),
          });
        }
        break;
      default: {
        data = getProjectGroupProjectFromCache({
          projectId,
        });

        writeProjectGroupProjectInCache({
          projectGroupId,
          projectId,
          data: {
            ...data,
            supervisors: !_.isEmpty(supervisorsArray)
              ? supervisorsArray
              : _.isEmpty(supervisor)
              ? []
              : [supervisor],
          },
        });
      }
    }

    try {
      await client.mutate({
        mutation: assignProjectToSupervisorMutation,
        variables: {
          projectId,
          addedArray,
          removedArray,
        },
      });
    } catch (e) {
      switch (type) {
        case "assign_with_invite":
          {
            writeProjectGroupStudentProjectFragmentInCache({
              id: projectId,
              academicYearId,
              projectFieldFilters: _.get(
                filterVariables,
                "projectFieldFilters",
                {}
              ),
              fetchFields: getShouldFetchFields({
                projectGroupType,
              }),
              fetchProjects: true,
              fetchProjectStudents: _.isEqual(
                projectGroupType,
                PROJECT_GROUP_TYPE_COMMUNITY
              ),
              data,
            });
          }
          break;
        default: {
          writeProjectGroupProjectInCache({
            projectGroupId,
            projectId,
            data,
          });
        }
      }
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw e;
    }
  };
};

export const inviteProjectGroupSupervisor = ({
  projectGroupId,
  addedArray,
  removedArray,
  filters,
  extraParams: { type = "", dashboardId = "", queryVariables = {} } = {},
  showSuccessToast = false,
  successToastDetails = {},
}) => {
  return async (dispatch, getState) => {
    // dont call the mutation if there is nothing to update
    if (
      (_.isEmpty(addedArray) && _.isEmpty(removedArray)) ||
      _.isEqual(_.sortBy(addedArray), _.sortBy(removedArray))
    ) {
      return;
    }
    const academicYearId = getSelectedAcademicYearId(getState());
    const academicYearIds = _.compact([academicYearId]);
    const projectGroupSupevisorFilters = filters;

    const dashboardFilters = _.get(getState(), "project.dashboardFilters");

    const { sortedFieldsWithOrder, projectFieldFilters, searchText } = _.get(
      dashboardFilters,
      dashboardId,
      {}
    );

    const staffNameOrderBy = entityNameOrderBy({
      entity: STAFF_USER,
      sortedFieldsWithOrder,
    });

    const refetchQueries = [];

    const projectFilters = {
      academicYearIds: academicYearIds,
    };

    const {
      getProjectGroupExternalSupervisorsWithProjectsVars = {},
    } = queryVariables;

    const updatedGetProjectGroupExternalSupervisorsWithProjectsVars = update(
      getProjectGroupExternalSupervisorsWithProjectsVars,
      {
        filters: {
          $set: {
            ...getProjectGroupExternalSupervisorsWithProjectsVars?.filters,
            academicYearIds,
          },
        },
      }
    );

    switch (type) {
      case "invite_portfolio_supervisor":
        {
          refetchQueries.push(
            {
              query: getProjectGroupSupervisorsWithPortfoliosQuery,
              variables: {
                projectGroupId,
                academicYearId,
                filters: {
                  searchText: searchText ? searchText : "",
                  orderBy: staffNameOrderBy,
                  orderByDirection: _.get(
                    sortedFieldsWithOrder,
                    "STAFF.direction",
                    ASC
                  ),
                  first: SUPERVISOR_FIRST_COUNT,
                  curriculumProgramIds: _.get(
                    projectGroupSupevisorFilters,
                    "curriculumProgramIds"
                  ),
                  supervisorType: PROJECT_SUPERVISOR_TYPE_INTERNAL,
                  academicYearIds,
                },
                portfolioFilters: {
                  academicYearIds,
                },
                projectFilters: {
                  academicYearIds,
                  projectArchivalState: PROJECT_ARCHIVAL_STATES.ACTIVE,
                },
              },
            },
            {
              query: getProjectGroupInternalSupervisorPendingApprovalCountQuery,
              variables: {
                projectGroupId,
                academicYearIds,
              },
              context: {
                useHttpLink: true,
              },
            },
            {
              query: getProjectGroupSupervisorsWithTypeCountQuery,
              variables: {
                projectGroupId,
                supervisorFilters: {
                  supervisorType: "INTERNAL",
                  approvalStatus: ["PENDING", "APPROVED"],
                  academicYearIds,
                },
              },
              context: {
                useHttpLink: true,
              },
            }
          );
        }
        break;
      case "invite_supervisor_saa":
        {
          refetchQueries.push(
            {
              query: getProjectGroupSupervisorsProjectsWithFieldsQuery,
              variables: {
                projectGroupId,
                academicYearId,
                filters: {
                  searchText: searchText ? searchText : "",
                  orderBy: staffNameOrderBy,
                  orderByDirection: _.get(
                    sortedFieldsWithOrder,
                    "STAFF.direction",
                    ASC
                  ),
                  first: SUPERVISOR_FIRST_COUNT,
                  curriculumProgramIds: _.get(
                    projectGroupSupevisorFilters,
                    "curriculumProgramIds"
                  ),
                  academicYearIds,
                },
                projectFieldFilters,
                projectFilters,
              },
            },
            {
              query: getProjectGroupSupervisorsWithTypeCountQuery,
              variables: {
                projectGroupId,
              },
              supervisorFilters: {
                supervisorType: "INTERNAL",
                approvalStatus: ["PENDING", "APPROVED"],
                academicYearIds,
              },
            },
            {
              query: getProjectGroupInternalSupervisorPendingApprovalCountQuery,
              variables: {
                projectGroupId,
                academicYearIds,
              },
            }
          );
        }
        break;
      case "invite_external_supervisor_cas":
        {
          refetchQueries.push(
            {
              query: getProjectGroupExternalSupervisorsWithProjectsQuery,
              variables: {
                projectGroupId,
                academicYearId,
                filters: {
                  searchText: searchText ? searchText : "",
                  orderBy: staffNameOrderBy,
                  orderByDirection: _.get(
                    sortedFieldsWithOrder,
                    "STAFF.direction",
                    ASC
                  ),
                  supervisorType: PROJECT_SUPERVISOR_TYPE_EXTERNAL,
                  first: SUPERVISOR_FIRST_COUNT,
                  academicYearIds,
                },
                projectFilters,
              },
            },
            {
              query: getProjectGroupExternalSupervisorPendingApprovalCountQuery,
              variables: {
                projectGroupId,
                academicYearIds,
              },
            },
            {
              query: getProjectGroupSupervisorsWithTypeCountQuery,
              variables: {
                projectGroupId,
                supervisorFilters: {
                  supervisorType: "EXTERNAL",
                  approvalStatus: ["PENDING", "APPROVED"],
                  academicYearIds,
                },
              },
            }
          );
        }
        break;
      case "invite_external_supervisor_screen_cas":
        {
          refetchQueries.push(
            {
              query: getProjectGroupExternalSupervisorsWithProjectsQuery,
              variables: updatedGetProjectGroupExternalSupervisorsWithProjectsVars,
            },
            {
              query: getProjectGroupSupervisorsWithTypeCountQuery,
              variables: {
                projectGroupId,
                supervisorFilters: {
                  supervisorType: "EXTERNAL",
                  approvalStatus: ["PENDING", "APPROVED"],
                  academicYearIds,
                },
              },
            }
          );
        }
        break;
      default: {
        refetchQueries.push(
          {
            query: getProjectGroupSupervisorsQuery,
            variables: {
              projectGroupId,
              filters: { ...projectGroupSupevisorFilters, academicYearIds },
              projectFilters,
              academicYearId,
            },
          },
          {
            query: getProjectGroupSupervisorsWithTypeCountQuery,
            variables: {
              projectGroupId,
              supervisorFilters: {
                supervisorType: "INTERNAL",
                approvalStatus: ["PENDING", "APPROVED"],
                academicYearIds,
              },
            },
          }
        );
      }
    }

    const [error] = await asyncWrap(
      client.mutate({
        mutation: inviteProjectGroupSupervisorMutation,
        variables: {
          projectGroupId,
          addedArray,
          removedArray,
        },
        awaitRefetchQueries: true,
        refetchQueries,
      })
    );
    if (error) dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    else if (showSuccessToast) {
      dispatch(
        setToastMsg({
          type: "success",
          msg: _.get(
            successToastDetails,
            "msg",
            "toastMsgs:successfully_with_label"
          ),
          locale_params: [
            ...successToastDetails.locale_params,
            {
              key: "label",
              value: "toastMsgs:updated",
              isPlainText: false,
            },
          ],
          timeOut: 5000,
        })
      );
    }
    return { error };
  };
};

export const assignSupervisorToProject = ({
  staffId,
  addedArray,
  removedArray,
  projectGroupId,
  projectsToUpdate = [],
  extraParams = {},
  staffIds = undefined,
  showSuccessToast = false,
  successToastDetails = {},
}) => {
  const { type = "", dashboardId } = extraParams;

  return async (dispatch, getState) => {
    // dont call the mutation if there is nothing to update
    if (
      _.isEmpty(addedArray) &&
      _.isEmpty(removedArray) &&
      _.isEmpty(projectsToUpdate)
    ) {
      return;
    }

    const academicYearId = getSelectedAcademicYearId(getState());
    const academicYearIds = _.compact([academicYearId]);
    const searchText = getState().invite.filters.supervisors.searchText;
    const filters = {
      searchText,
      first: SUPERVISOR_FIRST_COUNT,
      academicYearIds,
    };

    const { type: projectGroupType } = getCurrentProjectGroupDetails({
      state: getState(),
    });

    const refetchQueries = [];

    const dashboardFilters = _.get(getState(), "project.dashboardFilters");

    const {
      projectFieldFilters = {},
      sortedFieldsWithOrder,
      searchText: searchTerm,
    } = _.get(dashboardFilters, dashboardId, {});

    const studentNameOrderBy = entityNameOrderBy({
      entity: STUDENT_USER,
      sortedFieldsWithOrder,
    });
    const staffNameOrderBy = entityNameOrderBy({
      entity: STAFF_USER,
      sortedFieldsWithOrder,
    });
    const projectFilters = { academicYearIds };

    switch (type) {
      case "assign_with_invite":
        {
          const studentFilters = {
            searchText: searchTerm ? searchTerm : "",
            orderBy: studentNameOrderBy,
            orderByDirection: _.get(
              sortedFieldsWithOrder,
              "STUDENT.direction",
              ASC
            ),
            academicYearIds,
          };
          refetchQueries.push({
            query: getProjectGroupStudentsWithProjectsQuery,
            variables: {
              id: projectGroupId,
              academicYearId,
              projectFieldFilters,
              studentFilters,
              fetchFields: getShouldFetchFields({
                projectGroupType,
              }),
              fetchProjects: true,
              fetchProjectStudents: _.isEqual(
                projectGroupType,
                PROJECT_GROUP_TYPE_COMMUNITY
              ),
            },
          });
        }
        break;
      case "assign_with_invite_supervisor":
      case "edit_entity_projects":
        {
          refetchQueries.push({
            query: getProjectGroupSupervisorsQuery,
            variables: {
              projectGroupId: projectGroupId,
              filters: {
                searchText: searchTerm ? searchTerm : "",
                orderBy: staffNameOrderBy,
                orderByDirection: _.get(
                  sortedFieldsWithOrder,
                  "STAFF.direction",
                  ASC
                ),
                academicYearIds,
              },
              projectFilters,
              academicYearId,
            },
          });
        }
        break;
      case "edit_entity_experiences":
      case "edit_entity_activities":
      case "edit_entity_engagements":
        {
          refetchQueries.push({
            query: getProjectGroupSupervisorsWithPortfoliosQuery,
            variables: {
              projectGroupId,
              academicYearId,
              filters: {
                searchText: searchTerm ? searchTerm : "",
                orderBy: staffNameOrderBy,
                orderByDirection: _.get(
                  sortedFieldsWithOrder,
                  "STAFF.direction",
                  ASC
                ),
                first: SUPERVISOR_FIRST_COUNT,
                supervisorType: PROJECT_SUPERVISOR_TYPE_INTERNAL,
                academicYearIds,
              },
              portfolioFilters: {
                academicYearIds,
              },
              projectFilters: {
                academicYearIds,
                projectArchivalState: PROJECT_ARCHIVAL_STATES.ACTIVE,
              },
            },
          });
        }
        break;
      case "edit_entity_external_supervisor_experiences":
        {
          refetchQueries.push({
            query: getProjectGroupExternalSupervisorsWithProjectsQuery,
            variables: {
              projectGroupId,
              academicYearId,
              filters: {
                searchText: searchTerm ? searchTerm : "",
                orderBy: staffNameOrderBy,
                orderByDirection: _.get(
                  sortedFieldsWithOrder,
                  "STAFF.direction",
                  ASC
                ),
                supervisorType: PROJECT_SUPERVISOR_TYPE_EXTERNAL,
                first: SUPERVISOR_FIRST_COUNT,
                academicYearIds,
              },
              projectFilters,
            },
          });
        }
        break;
      case "edit_entity_activities_supervising":
        {
          refetchQueries.push({
            query: getProjectGroupSupervisorsProjectsWithFieldsQuery,
            variables: {
              projectGroupId,
              academicYearId,
              filters: {
                searchText: searchTerm ? searchTerm : "",
                orderBy: staffNameOrderBy,
                orderByDirection: _.get(
                  sortedFieldsWithOrder,
                  "STAFF.direction",
                  ASC
                ),
                first: SUPERVISOR_FIRST_COUNT,
                academicYearIds,
              },
              projectFieldFilters,
              projectFilters,
            },
          });
        }
        break;
      case "edit_entity_pending_approval_activities_supervising":
      case "edit_entity_pending_approval_experiences_supervising":
        {
          refetchQueries.push({
            query: getProjectGroupSupervisorApprovalInfoWithProjectsQuery,
            variables: {
              projectGroupId: projectGroupId,
              filters: {
                searchText: searchTerm ? searchTerm : "",
                approvalStatus: [SUPERVISOR_APPROVAL_STATUS_PENDING],
                orderBy: entityNameOrderBy({
                  entity: STAFF_USER,
                  sortedFieldsWithOrder,
                }),
                orderByDirection: _.get(
                  sortedFieldsWithOrder,
                  "STAFF.direction",
                  ASC
                ),
                supervisorType: PROJECT_SUPERVISOR_TYPE_INTERNAL,
                academicYearIds,
              },
              projectFieldFilters: {
                pseudoFieldUids: ["dateDuration", "image", "title"],
              },
              projectFilters,
              academicYearId,
            },
          });
        }
        break;
      case "edit_entity_pending_approval_experiences_supervising_by_external_supervisor":
        {
          refetchQueries.push({
            query: getProjectGroupSupervisorApprovalInfoWithProjectsQuery,
            variables: {
              projectGroupId: projectGroupId,
              filters: {
                searchText: searchTerm ? searchTerm : "",
                approvalStatus: [SUPERVISOR_APPROVAL_STATUS_PENDING],
                orderBy: entityNameOrderBy({
                  entity: STAFF_USER,
                  sortedFieldsWithOrder,
                }),
                orderByDirection: _.get(
                  sortedFieldsWithOrder,
                  "STAFF.direction",
                  ASC
                ),
                supervisorType: PROJECT_SUPERVISOR_TYPE_EXTERNAL,
                academicYearIds,
              },
              projectFieldFilters: {
                pseudoFieldUids: ["dateDuration", "image", "title"],
              },
              projectFilters,
              academicYearId,
            },
          });
        }
        break;
      default: {
        refetchQueries.push({
          query: getSupervisorProjectsQuery,
          variables: {
            staffId,
            filters: { projectGroupIds: [projectGroupId] },
          },
        });
      }
    }

    // JATIN : this will be removed once the new flow is live
    switch (projectGroupType) {
      case PROJECT_GROUP_TYPE_PERSONAL:
      case PROJECT_GROUP_TYPE_COMMUNITY:
        if (type !== "assign_with_invite") {
          refetchQueries.push({
            query: getProjectGroupSupervisorsQuery,
            variables: {
              projectGroupId,
              filters,
              projectFilters,
              academicYearId,
            },
          });
        }
        break;
    }

    try {
      await client.mutate({
        mutation: assignSupervisorToProjectMutation,
        variables: {
          staffId,
          // addedArray and removedArray does not override the previous mapped projects,
          // they just add or remove to the previous values
          addedArray,
          removedArray,
          projectsToUpdate, // projectsToUpdate will override the previous mapped projects,
          staffIds, // this will map projects to each staff of staffIds
        },
        awaitRefetchQueries: true,
        refetchQueries,
      });
      if (showSuccessToast) {
        dispatch(
          setToastMsg({
            type: "success",
            msg: _.get(
              successToastDetails,
              "msg",
              "toastMsgs:successfully_with_label"
            ),
            locale_params: [
              ...successToastDetails.locale_params,
              {
                key: "label",
                value: "toastMsgs:updated",
                isPlainText: false,
              },
            ],
            timeOut: 5000,
          })
        );
      }
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw e;
    }
  };
};

export const portfolioUpdateSupervisorAllocationForStudent = ({
  id,
  projectGroupId,
  staffId,
  studentId,
  staff,
  extraParams: { type = "" } = {},
}) => {
  return async (dispatch, getState) => {
    let data = {};
    const academicYearId = getSelectedAcademicYearId(getState());
    switch (type) {
      case "assign_with_invite":
        {
          data = getProjectGroupStudentPortfolioFragmentFromCache({
            id,
            academicYearId,
          });
          writeProjectGroupStudentPortfolioFragmentInCache({
            id,
            academicYearId,
            data: update(data, { staff: { $set: staff } }),
          });
        }
        break;
      default: {
        data = getStudentProjectPortfolioDetailsFromCache({
          id,
        });

        writeStudentProjectPortfolioDetailsFragmentInCache({
          id,
          data: update(data, { staff: { $set: staff } }),
        });
      }
    }

    try {
      await client.mutate({
        mutation: portfolioUpdateSupervisorAllocationForStudentMutation,
        variables: {
          projectGroupId,
          staffId,
          studentId,
        },
      });
    } catch (e) {
      switch (type) {
        case "assign_with_invite":
          {
            writeProjectGroupStudentPortfolioFragmentInCache({
              id,
              academicYearId,
              data,
            });
          }
          break;
        default: {
          writeStudentProjectPortfolioDetailsFragmentInCache({
            id,
            projectGroupId,
            data,
          });
        }
      }
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw e;
    }
  };
};

export const updateStaffApprovalStatus = ({
  supervisorIds = [],
  projectGroupToSupervisorMappingId = "",
  projectGroupId,
  approvalStatus,
  extraParams: {
    getProjectGroupSupervisorApprovalInfoWithProjectsVars = {},
    getProjectGroupSupervisorVars = {},
    getProjectGroupSupervisorsWithPortfoliosVars = {},
    getProjectGroupExternalSupervisorsWithProjectsVars = {},
    type = "",
    actionType = "",
  } = {},
  successToastDetails,
  showSuccessToast,
}) => {
  return async (dispatch, getState) => {
    const refetchQueries = [];
    const academicYearId = getSelectedAcademicYearId(getState());
    const academicYearIds = _.compact([academicYearId]);

    let cachedData = {};

    if (projectGroupToSupervisorMappingId) {
      // read and write in cache
      cachedData = readProjectGroupSupervisorApprovalStatusFragmentFromCache({
        id: projectGroupToSupervisorMappingId,
      });

      const updatedData = update(cachedData, {
        approvalStatus: { $set: approvalStatus },
      });

      writeProjectGroupSupervisorApprovalStatusInCache({
        id: projectGroupToSupervisorMappingId,
        data: updatedData,
      });
    }

    const updatedGetProjectGroupSupervisorVars = update(
      getProjectGroupSupervisorVars,
      {
        filters: {
          $set: {
            ...getProjectGroupSupervisorVars?.filters,
            academicYearIds,
          },
        },
        projectFilters: {
          $set: {
            ...getProjectGroupSupervisorVars?.projectFilters,
            academicYearIds,
          },
        },
        academicYearId: { $set: academicYearId },
      }
    );

    const updatedGetProjectGroupSupervisorsWithPortfoliosVars = update(
      getProjectGroupSupervisorsWithPortfoliosVars,
      {
        filters: {
          $set: {
            ...getProjectGroupSupervisorsWithPortfoliosVars?.filters,
            academicYearIds,
          },
        },
        portfolioFilters: {
          $set: {
            ...getProjectGroupSupervisorsWithPortfoliosVars?.portfolioFilters,
            academicYearIds,
          },
        },
        projectFilters: {
          $set: {
            ...getProjectGroupSupervisorsWithPortfoliosVars?.projectFilters,
            academicYearIds,
            projectArchivalState: PROJECT_ARCHIVAL_STATES.ACTIVE,
          },
        },
      }
    );

    const updatedGetProjectGroupExternalSupervisorsWithProjectsVars = update(
      getProjectGroupExternalSupervisorsWithProjectsVars,
      {
        filters: {
          $set: {
            ...getProjectGroupExternalSupervisorsWithProjectsVars?.filters,
            academicYearIds,
          },
        },
        projectFilters: {
          $set: {
            ...getProjectGroupExternalSupervisorsWithProjectsVars?.projectFilters,
            academicYearIds,
          },
        },
      }
    );

    // compute which queries to refetch based on type
    switch (type) {
      case "invite_supervisor_screen_saa":
        {
          refetchQueries.push({
            query: getProjectGroupInternalSupervisorPendingApprovalCountQuery,
            variables: {
              projectGroupId,
              academicYearIds,
            },
          });
          if (actionType == "reject") {
            refetchQueries.push({
              query: getProjectGroupSupervisorsProjectsWithFieldsQuery,
              variables: updatedGetProjectGroupSupervisorVars,
            });
          }
        }
        break;
      case "invite_supervisor_screen_portfolio":
        {
          refetchQueries.push(
            {
              query: getProjectGroupInternalSupervisorPendingApprovalCountQuery,
              variables: {
                projectGroupId,
                academicYearIds,
              },
            },
            {
              query: getProjectGroupExternalSupervisorPendingApprovalCountQuery,
              variables: {
                projectGroupId,
                academicYearIds,
              },
            }
          );
          if (actionType == "reject") {
            refetchQueries.push({
              query: getProjectGroupSupervisorsWithPortfoliosQuery,
              variables: updatedGetProjectGroupSupervisorsWithPortfoliosVars,
            });
          }
        }
        break;
      case "bulk_action_saa":
        {
          refetchQueries.push({
            query: getProjectGroupInternalSupervisorPendingApprovalCountQuery,
            variables: {
              projectGroupId,
              academicYearIds,
            },
          });
          refetchQueries.push(
            {
              query: getProjectGroupSupervisorApprovalInfoWithProjectsQuery,
              variables: getProjectGroupSupervisorApprovalInfoWithProjectsVars,
            },
            {
              query: getProjectGroupSupervisorsProjectsWithFieldsQuery,
              variables: updatedGetProjectGroupSupervisorVars,
            }
          );
        }
        break;
      case "bulk_action_portfolio":
        {
          refetchQueries.push({
            query: getProjectGroupInternalSupervisorPendingApprovalCountQuery,
            variables: {
              projectGroupId,
              academicYearIds,
            },
          });
          refetchQueries.push(
            {
              query: getProjectGroupSupervisorApprovalInfoWithProjectsQuery,
              variables: getProjectGroupSupervisorApprovalInfoWithProjectsVars,
            },
            {
              query: getProjectGroupSupervisorsWithPortfoliosQuery,
              variables: updatedGetProjectGroupSupervisorsWithPortfoliosVars,
            }
          );
        }
        break;
      case "bulk_action_cas_external":
        {
          refetchQueries.push(
            {
              query: getProjectGroupSupervisorApprovalInfoWithProjectsQuery,
              variables: getProjectGroupSupervisorApprovalInfoWithProjectsVars,
            },
            {
              query: getProjectGroupExternalSupervisorsWithProjectsQuery,
              variables: updatedGetProjectGroupExternalSupervisorsWithProjectsVars,
            },
            {
              query: getProjectGroupExternalSupervisorPendingApprovalCountQuery,
              variables: {
                projectGroupId,
                academicYearIds,
              },
            },
            {
              query: getProjectGroupSupervisorsWithTypeCountQuery,
              variables: {
                projectGroupId,
                supervisorFilters: {
                  supervisorType: "EXTERNAL",
                  approvalStatus: ["PENDING", "APPROVED"],
                  academicYearIds,
                },
              },
            }
          );
        }
        break;
      case "invite_external_supervisor_screen_cas": {
        refetchQueries.push({
          query: getProjectGroupExternalSupervisorPendingApprovalCountQuery,
          variables: {
            projectGroupId,
            academicYearIds,
          },
        });
        if (actionType == "reject") {
          refetchQueries.push(
            {
              query: getProjectGroupExternalSupervisorsWithProjectsQuery,
              variables: updatedGetProjectGroupExternalSupervisorsWithProjectsVars,
            },
            {
              query: getProjectGroupSupervisorsWithTypeCountQuery,
              variables: {
                projectGroupId,
                supervisorFilters: {
                  supervisorType: "EXTERNAL",
                  approvalStatus: ["PENDING", "APPROVED"],
                  academicYearIds,
                },
              },
            }
          );
        }
      }
    }

    try {
      await client.mutate({
        mutation: updateProjectGroupSupervisorApprovalStatusMutation,
        variables: {
          id: projectGroupId,
          approvalStatus,
          supervisorIds,
        },
        awaitRefetchQueries: true,
        refetchQueries,
      });
      if (showSuccessToast) {
        dispatch(
          setToastMsg({
            type: "success",
            msg: _.get(
              successToastDetails,
              "msg",
              "toastMsgs:successfully_with_label"
            ),
            locale_params: [
              ...successToastDetails.locale_params,
              {
                key: "label",
                value: "toastMsgs:updated",
                isPlainText: false,
              },
            ],
            timeOut: 5000,
          })
        );
      }
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      if (projectGroupToSupervisorMappingId) {
        writeProjectGroupSupervisorApprovalStatusInCache({
          id: projectGroupToSupervisorMappingId,
          data: cachedData,
        });
      }
      console.error(e);
    }
  };
};

export const bulkAssignAdvisorToStudents = ({
  projectGroupId,
  staffId,
  addedStudents,
  removedStudents = [],
  extraParams: { dashboardId = "", type = "" } = {},
}) => {
  return async (dispatch, getState) => {
    // if nothing to update dont fire mutation
    if (_.isEmpty(addedStudents) && _.isEmpty(removedStudents)) {
      return;
    }
    const academicYearId = getSelectedAcademicYearId(getState());
    const academicYearIds = _.compact([academicYearId]);
    const { type: projectGroupType } = getCurrentProjectGroupDetails({
      state: getState(),
    });
    const dashboardFilters = getState().project.dashboardFilters;
    const { sortedFieldsWithOrder = [], searchText = "" } = _.get(
      dashboardFilters,
      dashboardId,
      {}
    );

    const orderByFields = getOrderByFieldsMemoized({
      sortedFieldsWithOrder,
    });

    const studentNameOrderBy = entityNameOrderBy({
      entity: STUDENT_USER,
      sortedFieldsWithOrder,
    });
    const staffNameOrderBy = entityNameOrderBy({
      entity: STAFF_USER,
      sortedFieldsWithOrder,
    });

    const refetchQueries = [];

    switch (type) {
      case "assign_with_invite":
        {
          refetchQueries.push({
            query: getProjectGroupStudentsWithPortfoliosQuery,
            variables: {
              id: projectGroupId,
              academicYearId,
              studentFilters: {
                portfolioAdvisers: [],
                searchText,
                first: STUDENT_FIRST_COUNT,
                orderBy: studentNameOrderBy,
                orderByDirection: _.get(
                  sortedFieldsWithOrder,
                  "STUDENT.direction",
                  ASC
                ),
                academicYearIds,
              },
              studentProjectPortfolioFilter: {
                projectGroupTypes: [projectGroupType],
              },
            },
          });
        }
        break;
      case "assign_with_invite_supervisor":
        {
          refetchQueries.push({
            query: getProjectGroupSupervisorsWithPortfoliosQuery,
            variables: {
              projectGroupId,
              academicYearId,
              filters: {
                searchText: "",
                orderBy: staffNameOrderBy,
                orderByDirection: _.get(
                  sortedFieldsWithOrder,
                  "STAFF.direction",
                  ASC
                ),
                supervisorType: PROJECT_SUPERVISOR_TYPE_INTERNAL,
                first: SUPERVISOR_FIRST_COUNT,
                academicYearIds,
              },
              portfolioFilters: {
                academicYearIds,
              },
              projectFilters: {
                academicYearIds,
                projectArchivalState: PROJECT_ARCHIVAL_STATES.ACTIVE,
              },
            },
          });
        }
        break;
      default: {
        refetchQueries.push({
          query: getProjectGroupStudentPortfoliosQuery,
          variables: {
            projectGroupId,
            filters: {
              advisers: [],
              searchText: "",
              first: BULK_MAP_ADVISER_FIRST_COUNT,
              orderBy: _.isEqual(_.size(orderByFields), 0)
                ? undefined
                : orderByFields,
              academicYearIds,
            },
          },
        });
      }
    }

    try {
      await client.mutate({
        mutation: portfolioUpdateStudentsAllocationForSupervisorMutation,
        variables: {
          projectGroupId,
          staffId,
          addedStudents,
          removedStudents,
        },
        awaitRefetchQueries: true,
        refetchQueries,
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw e;
    }
  };
};

export const inviteProjectStudents = ({
  studentIdsToInvite,
  projectIdsToRemove,
  projectGroupId,
  projectGroupProjectFilters,
}) => {
  return async (dispatch, getState) => {
    // if nothing to update dont fire mutation
    if (_.isEmpty(studentIdsToInvite) && _.isEmpty(projectIdsToRemove)) {
      return;
    }
    const academicYearId = getSelectedAcademicYearId(getState());
    const academicYearIds = _.compact([academicYearId]);
    const projectGroupSupervisorsFilters = {
      searchText: getState().invite.filters.supervisors.searchText,
      first: SUPERVISOR_FIRST_COUNT,
      academicYearIds,
    };

    const updatedProjectGroupProjectFilters = update(
      projectGroupProjectFilters,
      {
        academicYearIds: { $set: academicYearIds },
      }
    );

    try {
      await client.mutate({
        mutation: inviteProjectStudentMutation,
        variables: {
          studentIdsToInvite,
          projectIdsToRemove,
          projectGroupId,
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getProjectGroupProjectsQuery,
            variables: {
              projectGroupId,
              filters: updatedProjectGroupProjectFilters,
            },
          },
          {
            query: getProjectGroupSupervisorsWithTypeCountQuery,
            variables: {
              projectGroupId,
              supervisorFilters: {
                supervisorType: "INTERNAL",
                approvalStatus: ["PENDING", "APPROVED"],
                academicYearIds,
              },
            },
          },
          {
            query: getProjectGroupSupervisorsQuery,
            variables: {
              projectGroupId,
              filters: projectGroupSupervisorsFilters,
              projectFilters: {
                academicYearIds,
              },
              academicYearId,
            },
          },
          {
            query: getProjectGroupProjectsCountQuery,
            variables: {
              projectGroupId,
              filters: {
                academicYearIds,
              },
            },
          },
        ],
      });
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw e;
    }
  };
};

export const inviteProjectGroupStudents = ({
  projectGroupId,
  addArray,
  removeArray,
  extraParams: { type = "" } = {},
  queryVars = {},
  showSuccessToast = false,
  successToastDetails = {},
}) => {
  return async (dispatch, getState) => {
    // if nothing to update dont fire mutation
    if (_.isEmpty(addArray) && _.isEmpty(removeArray)) {
      return;
    }
    const academicYearId = getSelectedAcademicYearId(getState());
    const academicYearIds = _.compact([academicYearId]);
    const defaultStudentNameSortPreference = getDefaultNameSortPreference(
      getState
    );

    const filters = {
      searchText: getState().invite.filters.studentCommunityProject.searchText,
      first: STUDENT_COMMUNITY_FIRST_COUNT,
      orderBy: defaultStudentNameSortPreference
        ? defaultStudentNameSortPreference
        : FIRST_NAME,
      orderByDirection: ASC,
    };

    const refetchQueries = [];

    const {
      projectGroupStudentsWithProjectsVars = {},
      projectGroupStudentsWithPortfoliosVars = {},
    } = queryVars;

    const updatedProjectGroupStudentsWithProjectsVars = update(
      projectGroupStudentsWithProjectsVars,
      {
        studentFilters: {
          $set: {
            ...projectGroupStudentsWithProjectsVars?.studentFilters,
            academicYearIds,
          },
        },
      }
    );

    const updatedProjectGroupStudentsWithPortfoliosVars = update(
      projectGroupStudentsWithPortfoliosVars,
      {
        studentFilters: {
          $set: {
            ...projectGroupStudentsWithPortfoliosVars?.studentFilters,
            academicYearIds,
          },
        },
        academicYearId: { $set: academicYearId },
      }
    );

    switch (type) {
      case "newInviteFlow":
        {
          refetchQueries.push(
            {
              query: getProjectGroupStudentCountQuery,
              variables: {
                projectGroupId,
                filters: {
                  academicYearIds,
                },
              },
            },
            {
              query: getProjectGroupStudentsWithProjectsQuery,
              variables: updatedProjectGroupStudentsWithProjectsVars,
            }
          );
        }
        break;
      case "newInviteFlowCAS":
        {
          refetchQueries.push(
            {
              query: getProjectGroupStudentsWithPortfoliosQuery,
              variables: updatedProjectGroupStudentsWithPortfoliosVars,
            },
            {
              query: getProjectGroupStudentCountQuery,
              variables: {
                projectGroupId,
                filters: {
                  academicYearIds,
                },
              },
            }
          );
        }
        break;
      default: {
        refetchQueries.push(
          {
            query: getProjectGroupStudentCountQuery,
            variables: {
              projectGroupId,
              filters: {
                academicYearIds,
              },
            },
          },
          {
            query: getProjectGroupStudentsQuery,
            variables: {
              id: projectGroupId,
              filters: {
                ...filters,
                academicYearIds,
              },
            },
          }
        );
      }
    }

    try {
      await client.mutate({
        mutation: inviteProjectGroupStudentsMutation,
        variables: {
          projectGroupId,
          addArray,
          removeArray,
        },
        awaitRefetchQueries: true,
        refetchQueries,
      });
      if (showSuccessToast) {
        dispatch(
          setToastMsg({
            type: "success",
            msg: _.get(
              successToastDetails,
              "msg",
              "toastMsgs:successfully_with_label"
            ),
            locale_params: [
              ...successToastDetails.locale_params,
              {
                key: "label",
                value: "toastMsgs:updated",
                isPlainText: false,
              },
            ],
            timeOut: 5000,
          })
        );
      }
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

const REDUCER_HANDLERS = {
  [UPDATE_FILTER]: (state, action) => {
    const params = action.data;
    const { key, filter, filterData } = params;
    return update(state, {
      filters: {
        [key]: {
          [filter]: { $set: filterData },
        },
      },
    });
  },
  [RESET_FILTER]: (state, action) => {
    const params = action.data;
    const { key, filter } = params;
    return update(state, {
      filters: {
        [key]: { [filter]: { $set: initialState.filters[key][filter] } },
      },
    });
  },
};

const initialState = {
  filters: {
    supervisors: {
      searchText: "",
    },
    students: {
      searchText: "",
    },
    projects: {
      searchText: "",
    },
    studentCommunityProject: {
      searchText: "",
    },
  },
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
